module.exports = __webpack_public_path__ + "img/plan-1-1.8ea47dd6.png";